import { STATION_TYPE_CONSTANT } from 'station/constants/StationConstants'

export default class DtoProductionUnitLinkedPiezo {
    constructor(obj) {
        this.idPiezometer = obj.idPiezometer // Option[Long],
        this.code = obj.code // Option[String],
        this.designation = obj.designation // Option[String],
        this.name = obj.name // Option[String],
        this.measureDate = obj.measureDate // Option[DateTime],
        this.value = obj.value // Option[Double]
        this.type = STATION_TYPE_CONSTANT.piezometry
    }
}